// src/redux/Reducers/studentPlacementAnswersReducer.js
import {
  STUDENT_SET_MCQ_SELECTION,
  STUDENT_SET_LESEN_SELECTION,
  STUDENT_SET_AUDIO_SELECTION,
  STUDENT_SET_SCHREIBEN_TEXT,
  STUDENT_AUDIO_PLAY_INCREMENT,
  STUDENT_AUDIO_BLOCK,
  STUDENT_ANSWERS_RESET,
} from "../Actions/types";

const initialState = {
  // store both index & text so we can submit without reloading question arrays
  mcq:    { /* [questionId]: { index, text } */ },
  lesen:  { /* [questionId]: { index, text } */ },
  audio:  { /* [questionId]: { index, text } */ },

  // writing
  schreibenText: "",

  // global audio limit (shared player, 2 plays max)
  audioLimit: { playCount: 0, blocked: false },
};

const studentPlacementAnswersReducer = (state = initialState, action) => {
  switch (action.type) {
    case STUDENT_SET_MCQ_SELECTION:
      return { ...state, mcq: { ...state.mcq, [action.payload.qid]: { index: action.payload.index, text: action.payload.text } } };

    case STUDENT_SET_LESEN_SELECTION:
      return { ...state, lesen: { ...state.lesen, [action.payload.qid]: { index: action.payload.index, text: action.payload.text } } };

    case STUDENT_SET_AUDIO_SELECTION:
      return { ...state, audio: { ...state.audio, [action.payload.qid]: { index: action.payload.index, text: action.payload.text } } };

    case STUDENT_SET_SCHREIBEN_TEXT:
      return { ...state, schreibenText: action.payload };

    case STUDENT_AUDIO_PLAY_INCREMENT: {
      const next = state.audioLimit.playCount + 1;
      return { ...state, audioLimit: { playCount: next, blocked: state.audioLimit.blocked || next >= 2 } };
    }

    case STUDENT_AUDIO_BLOCK:
      return { ...state, audioLimit: { ...state.audioLimit, blocked: true } };

    case STUDENT_ANSWERS_RESET:
      return initialState;

    default:
      return state;
  }
};

export default studentPlacementAnswersReducer;
